export const isToday = (date: Date | string) => {
    const d = new Date(date);
    const today = new Date();
    
    // Normalize both dates to midnight to avoid timezone issues
    const dMidnight = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    
    return dMidnight.getTime() === todayMidnight.getTime();
};

export const isThisWeek = (date: Date | string) => {
    const d = new Date(date);
    const today = new Date();
    const firstDayOfWeek = new Date(today);
    // Assuming week starts on Monday (1)
    const day = today.getDay();
    const diff = today.getDate() - day + (day === 0 ? -6 : 1);
    firstDayOfWeek.setDate(diff);
    firstDayOfWeek.setHours(0, 0, 0, 0);

    return d >= firstDayOfWeek;
};

export const isWeeklyQuestDay = (weeklyDay: number) => {
    const today = new Date();
    // JavaScript getDay() returns 0 for Sunday, 1 for Monday, etc.
    // Our weekly_day uses the same convention (0=Sunday, 1=Monday, ..., 6=Saturday)
    return today.getDay() === weeklyDay;
};
